import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { IdentityRoleSortBy } from '@/generated/Enumerations/IdentityRoleSortBy_pb'
import { IdentityRoleFiltersDto } from '@/generated/Messages/Filters_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import {
    listQueryKeyPrefix,
    userRolesQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

export const userRolesListQueryKeyPrefix = [
    userRolesQueryKeyPrefix,
    listQueryKeyPrefix,
] as const

export const userRolesOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    filter: Partial<OmitDeepMessageFields<IdentityRoleFiltersDto>> = {}
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...userRolesListQueryKeyPrefix, filter],
        queryFn: async ({ signal }) => {
            assertNotNullish(clients?.role)

            const response = await clients.role.getRoles(
                {
                    ids: [],
                    sorting: [
                        {
                            sortBy: IdentityRoleSortBy.NAME,
                            descending: false,
                        },
                    ],
                    searching: [],
                },
                { signal }
            )

            return response
        },
        enabled: !clients?.user,
    })

export const useUserRoles = () => {
    const clients = useGrpcClients()

    return useSuspenseQuery(userRolesOptions(clients))
}
